import { MetricLengthUnit } from '@/models/generics'
import { CtPacking } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true
    },
    dimensions: {
      field: 'dimensions',
      label: 'Dimensions',
      validator: () => true,
      type: 'json',
      default: {x: 0, y: 0, z: 0, capacity: 0, unit: MetricLengthUnit.Centimeter},
      required: true
    },
    weight: {
      field: 'weight',
      label: 'Weight',
      validator: () => true,
      type: 'string',
      default: 0,
      required: true
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtPacking>(
  ContentType.Packing, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
